import {Component, OnInit, ViewChild} from '@angular/core';
import {MenuService} from "../../core/menu/menu.service";
import {UserblockService} from "../sidebar/userblock/userblock.service";
import { SettingsService } from "../../core/settings/settings.service";
import { Router } from '@angular/router';

const screenfull = require('screenfull');
const browser = require('jquery.browser');
declare var $: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    showHeader = true;
    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout

    static singleton: HeaderComponent;
    shopName: string = "AHA Accounting";
    public static setTitle(str: string) {
        if (!str || str == null || str == undefined || str.length == 0) { str = 'AHA Accounting'; }
        // console.log('str: ' + str);
        try {
            if (HeaderComponent.singleton) { HeaderComponent.singleton.shopName = str.split(',')[0]; }
        } catch (err) {
            // console.log(err);
            if (HeaderComponent.singleton) { HeaderComponent.singleton.shopName = 'AHA Accounting'; }
        }
    }

    isNavSearchVisible: boolean;
    isBackStoreEnable = '1';
    @ViewChild('fsbutton') fsbutton; // the fullscreen button

    constructor(public router: Router,
                public menu: MenuService,
                public userblockService: UserblockService,
                public settings: SettingsService) {
        this.isBackStoreEnable = localStorage.getItem('isBackStoreEnable');
        HeaderComponent.singleton = this;
    }

    ngOnInit() {
        this.isNavSearchVisible = false;
        if (browser.msie) { // Not support under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }
        this.showHeader = this.router.url != '/stores';
    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    toggleFullScreen(event) {

        if (screenfull.enabled) {
            screenfull.toggle();
        }
        // Switch icon indicator
        let el = $(this.fsbutton.nativeElement);
        if (screenfull.isFullscreen) {
            el.children('em').removeClass('fa-expand').addClass('fa-compress');
        }
        else {
            el.children('em').removeClass('fa-compress').addClass('fa-expand');
        }
    }
    backStores(){
        localStorage.removeItem('shopID');
        localStorage.removeItem('shopName');
        localStorage.removeItem('shopAddress');
        localStorage.setItem('isBackStoreEnable', '0');
        this.router.navigateByUrl('/store');
        // location.href = '/stores';
    }
}
